<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-text" style="width: 100%">
        <!-- Nhập nội dung của nút -->
        <mat-form-field style="width: 100%">
          <mat-label> {{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
            (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('content');"></textarea>
        </mat-form-field>
        <!-- Nếu nội dung không có thì phải có nhãn -->
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
        *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
          <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
            (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('aria_label', true);"></textarea>
        </mat-form-field>
      </div>

      <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
      [staticdata]="staticdata" [textContentClass]="class['button__content']" [textWrapperClass]="class['button']"
      (changeTextAlignConfig)="changeWidthHeight({width: width})">
      </app-text-format-config>

      <div class="color-pick">
        <span class="title w-50">{{'mau_nen' | translate}}</span>
        <input class="input-color w-50" type="button" [cpOKButton]="true"
          [(colorPicker)]="class['button']['background-color']"
          [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
          [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
          [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
          [cpPresetLabel]="'bang_mau_mau' | translate"
          [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
          (cpPresetColorsChange)="themeService.presetColorsChange($event)"
          (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
      </div>

      <!-- Mở popup so sánh màu tương phản -->
      <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
      nz-row (click)="openColorContrast()" nz-tooltip
      [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
      style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
        {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
      </button>

      <ng-container *ngIf="objectChoosing.component == 'AtwDeleteCartProduct'">
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['button']"
          [fontSizeIconClass]="class['button__content--icon-wrapper']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </ng-container>
  
      <!-- Không phải AtwButton -->
      <app-link-page-config [objectChoosing]="objectChoosing"
      *ngIf="objectChoosing.component !== 'AtwButton' && objectChoosing.component !== 'AtwButtonAddToCart' && objectChoosing.component !== 'AtwButtonOpenLink'"
      [staticdata]="staticdata" [id_object]="objectChoosing._id"
      [blocks_of_page]="blocks_of_page"></app-link-page-config>
  
      <!-- <app-link-page-config [objectChoosing]="objectChoosing"
        *ngIf="objectChoosing.component === 'AtwButtonAddToCart'" [type_page]="['detail_product']"
        [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config> -->
      <!-- Là AtwButton -->
      <app-link-page-config [objectChoosing]="objectChoosing" *ngIf="objectChoosing.component === 'AtwButton'"
        [id_object]="objectChoosing._id" [staticdata]="staticdata" [blocks_of_page]="blocks_of_page"
        [dynamic_data]="objectChoosing.dynamic_data" [hasContact]="true">
      </app-link-page-config>

      <ng-container *ngIf="objectChoosing.component == 'AtwButtonAddToCart'">
        <div class="config-name mt-4">
          <p>{{'loai_hien_thi_khi_het_hang' | translate}}</p>
          <nz-select [ngModel]="config.out_stock_display_type" (ngModelChange)="config.out_stock_display_type = $event; updateConfig();">
            <nz-option nzValue="hide" nzLabel="{{'an_nut_di' | translate}}"></nz-option>
            <nz-option nzValue="disable" nzLabel="{{'vo_hieu_hoa' | translate}}"></nz-option>
            <nz-option nzValue="message" nzLabel="{{'thong_bao' | translate}}"></nz-option>
          </nz-select>
        </div>

        <ng-container *ngIf="config.out_stock_display_type == 'disable'">
          <div class="config-name mt-2">
            <p>{{'bat_vo_hieu_hoa_tam_thoi' | translate}}</p>
            <nz-switch [ngModel]="config.is_disabled_temp" (ngModelChange)="config.is_disabled_temp = $event"></nz-switch>
          </div>
          <ng-container *ngIf="config.is_disabled_temp">
            <div class="config-name mt-2">
              <p>{{'do_mo' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="1" style="max-width: 50%" [nzStep]="0.01"
                [(ngModel)]="class['button--disabled']['opacity']" (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <div class="config-name mt-2">
              <p>{{'mau_chu' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['button--disabled']['color']"
                [style.background]="class['button--disabled']['color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
            <div class="config-name mt-2">
              <p>{{'mau_nen' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['button--disabled']['background-color']"
                [style.background]="class['button--disabled']['background-color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="config.out_stock_display_type == 'message'">
          <button class="w-100 mt-2" (click)="handleTryNoti()" nz-button nzType="primary">
            {{'thong_bao_thu' | translate}}
          </button>
          <div class="config-text mt-2" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung_thong_bao' | translate}}</mat-label>
              <textarea matInput style="height: 50px; line-height: 1.4"
                [ngModel]="staticdata['content_noti_out_stock_' + functionService.selectedLanguageCode] | vhLanguage : 'Sản phẩm hết hàng' : objectChoosing.component"
                (ngModelChange)="staticdata['content_noti_out_stock_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content_noti_out_stock');"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
        <hr />
        <!-- CẤU HÌNH KHI CHƯA ĐĂNG NHẬP -->
        <h2>{{'cau_hinh_khi_CHUA_dang_nhap' | translate}}</h2>
        <!-- Cấu hình nội dung thông báo và thời gian hiển thị thông báo -->
        <ng-container *ngTemplateOutlet="notificationBlock; context: {
          dataKey: 'content_login_notice',
          configKey: 'login_notice', label: 'noi_dung_thong_bao'
        }"></ng-container>
        <!-- Cấu hình liên kết -->
        <app-link-page-config [objectChoosing]="objectChoosing" [blocks_of_page]="blocks_of_page"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [linkStaticdata]="staticdata.not_logged_link">
        </app-link-page-config>
        <!-- Thời gian chuyển trang sau khi hiển thị thông báo -->
        <div *ngIf="staticdata.not_logged_link.type_link && staticdata.not_logged_link.type_link != 'none'" 
        style="display:flex; justify-content:space-between; align-items:center">
          <span style="line-height:1.2; width: 60%">
            {{ 'thoi_gian_chuyen_trang_sau_khi_hien_thi_thong_bao' | translate }}
            <span style="font-weight: bold;"> (ms)</span>
          </span>
          <nz-input-number
            [nzMin]="0" [nzMax]="5000" [nzStep]="100"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="staticdata.not_logged_link?.page_delay_after_noti | vhnumber"
            (ngModelChange)="staticdata.not_logged_link.page_delay_after_noti = $event"
            (nzBlur)="updateStaticData()">
          </nz-input-number>
        </div>
        <hr />
        <!-- CẤU HÌNH KHI ĐÃ ĐĂNG NHẬP -->
        <h2>{{'cau_hinh_khi_DA_dang_nhap' | translate}}</h2>
        <!-- Cấu hình liên kết -->
        <app-link-page-config [objectChoosing]="objectChoosing" [blocks_of_page]="blocks_of_page"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [linkStaticdata]="staticdata.logged_link">
        </app-link-page-config>
        <!-- Thời gian chuyển trang sau khi hiển thị thông báo -->
        <div *ngIf="staticdata.logged_link.type_link && staticdata.logged_link.type_link != 'none'" 
        style="display:flex; justify-content:space-between; align-items:center">
          <span style="line-height:1.2; width: 60%">
            {{ 'thoi_gian_chuyen_trang_sau_khi_hien_thi_thong_bao' | translate }}
            <span style="font-weight: bold;"> (ms)</span>
          </span>
          <nz-input-number
            [nzMin]="0" [nzMax]="5000" [nzStep]="100"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="staticdata.logged_link?.page_delay_after_noti | vhnumber"
            (ngModelChange)="staticdata.logged_link.page_delay_after_noti = $event"
            (nzBlur)="updateStaticData()">
          </nz-input-number>
        </div>
      </ng-container>

        <!-- Cấu hình thêm liên kết -->
      <ng-container *ngIf="objectChoosing.component == 'AtwButtonOpenLink'">
          <div class="type-link mb-2">
            <p class="type-link__title m-0" style="line-height: normal">{{'kieu_mo_lien_ket' | translate}}</p>
            <nz-select class="type-link__select" [(ngModel)]="staticdata.target" (ngModelChange)="updateStaticData()"
              nzPlaceHolder="{{'kieu_mo_lien_ket' | translate}}" allowClear>
              <nz-option [nzValue]="'_blank'" nzLabel="{{'mo_trang_moi' | translate}}"></nz-option>
              <nz-option [nzValue]="'_self'" nzLabel="{{'mo_tai_trang_hien_tai' | translate}}"></nz-option>
            </nz-select>
          </div>

          
          <div class="type-link">
            <p class="type-link__title  m-0" style="line-height: normal">{{'vi_tri_noi_dung' | translate}}</p>
            <nz-select class="type-link__select" [(ngModel)]="staticdata.index_reference_link" (ngModelChange)="updateStaticData()"
              nzPlaceHolder="{{'kieu_mo_lien_ket' | translate}}" allowClear>
              <nz-option [nzValue]="0" nzLabel="{{'1' | translate}}"></nz-option>
              <nz-option [nzValue]="1" nzLabel="{{'2' | translate}}"></nz-option>
              <nz-option [nzValue]="2" nzLabel="{{'3' | translate}}"></nz-option>
              <nz-option [nzValue]="3" nzLabel="{{'4' | translate}}"></nz-option>
              <nz-option [nzValue]="4" nzLabel="{{'5' | translate}}"></nz-option>
            </nz-select>
          </div>

      </ng-container>

    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>
  <!-- Cấu hình nâng cao -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'" >
    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <div *ngIf="objectChoosing.component == 'AtwButtonPayment'" class="item-symbol">
            <p class="title" style="line-height: 1.5">{{'thanh_toan_online' | translate}}</p>
            <nz-switch [(ngModel)]="staticdata.payment_online" (ngModelChange)="updateStaticData()"></nz-switch>
          </div>
        </div>
      </li>
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">

        <div class="container-font">
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content');"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label');"></textarea>
            </mat-form-field>
          </div>
          <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [textContentClass]="class['button__content']" [textWrapperClass]="class['button']"
            (changeTextAlignConfig)="changeWidthHeight({width: width})">
          </app-text-format-config>
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLetterSpacing]="class['button__content']" (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLineHeight]="class['button__content']" (updateClass)="updateClass()">
          </app-line-height-config>
          <!-- Khoảng đệm bên trái của chữ -->
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['button__content']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
          </app-padding-config>
          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items justify-content-between">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="padding" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [(ngModel)]="config['padding']" (nzBlur)="updateConfig(); changeWidthHeight({width: width})">
              </nz-input-number>
            </div>
            <!-- <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-top.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-top'] | vhnumber" (nzBlur)="updateClassAndWidthHeight();updateDimension()"
                (ngModelChange)="
                  class['button']['padding-top'] = $event + 'px';
                  class['button']['padding-bottom'] = $event + 'px'
                "></nz-input-number>
            </div>
            <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-left'] | vhnumber" (nzBlur)="updateClassAndWidthHeight();updateDimension()"
                (ngModelChange)="
                  class['button']['padding-right'] = $event + 'px';
                  class['button']['padding-left'] = $event + 'px'
                "></nz-input-number>
            </div> -->
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['background-color'].gradient_check"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)"
            (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mau_gradient' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['button']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['button']"
          [fontSizeIconClass]="class['button__content--icon-wrapper']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['button']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>

      <!-- TEMPLATE: CẤU HÌNH THÔNG BÁO -->
      <ng-template #notificationBlock let-dataKey="dataKey" let-configKey="configKey" let-label="label">
        <div class="config-text" style="width: 100%">
          <!-- Cấu hình nội dung -->
          <mat-form-field style="width: 100%">
            <mat-label> {{label | translate}}</mat-label>
            <textarea matInput
              [ngModel]="staticdata[dataKey + '_' + functionService.selectedLanguageCode]"
              (ngModelChange)="staticdata[dataKey + '_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateContent(dataKey)"></textarea>
          </mat-form-field>
          <!-- Cấu hình thời gian hiển thị thông báo -->
          <div style="display:flex; justify-content:space-between; align-items:center">
            <span class="w-50" style="line-height:1.2;">{{ 'thoi_gian_hien_thong_bao' | translate }}</span>
            <nz-input-number
              [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="config.duration_noti?.[configKey] | vhnumber"
              (ngModelChange)="config.duration_noti[configKey] = $event"
              (nzBlur)="updateConfig()" class="w-50">
            </nz-input-number>
          </div>
          <hr />
        </div>
      </ng-template>

      <!-- CẤU HÌNH THÔNG BÁO -->
      <li *ngIf="['AtwSendContact', 'AtwButtonPayment', 'AtwButtonPaymentOnline', 'AtwUseTemplate', 'AtwDeleteCartProduct', 'AtwQrBanking', 'AtwSendCV', 'AtwButtonRegister'].includes(objectChoosing.component)"
      nz-submenu nzTitle="{{'cau_hinh_thong_bao' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
        <!-- Cấu hình nội dung xác nhận thanh toán -->
        <ng-container *ngIf="['AtwButtonPayment', 'AtwButtonPaymentOnline'].includes(objectChoosing.component)">
          <div class="item-symbol">
            <p class="title" style="line-height: 1.5">{{'thong_bao_xac_nhan_thanh_toan' | translate}}</p>
            <nz-switch [(ngModel)]="staticdata.confirm_payment_enable" (ngModelChange)="updateStaticData()"></nz-switch>
          </div>
          <mat-form-field style="width: 100%">
            <mat-label> {{'thong_bao_xac_nhan_thanh_toan' | translate}}</mat-label>
            <textarea matInput
              [(ngModel)]="staticdata['content_confirm_payment_' + functionService.selectedLanguageCode]"
              (blur)="updateContent('content_confirm_payment')"></textarea>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="['AtwButtonPayment', 'AtwButtonPaymentOnline', 'AtwDeleteCartProduct', 'AtwQrBanking'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_notification',
            configKey: 'notification', label: (objectChoosing.component == 'AtwButtonPayment' || objectChoosing.component == 'AtwButtonPaymentOnline' ? 'thong_bao_gio_hang_trong' : 'noi_dung') | translate
          }"></ng-container>
        </ng-container>



        <ng-container *ngIf="['AtwUseTemplate'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_login_notice',
            configKey: 'login_notice', label: 'bao_dang_nhap'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwSendContact'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_notification',
            configKey: 'notification', label: 'gui_lien_he_thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_phone_required',
            configKey: 'phone_required', label: 'bat_buoc_nhap_so_dien_thoai'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_phone_valid',
            configKey: 'phone_valid', label: 'so_dien_thoai_khong_dung_dinh_dang'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_mail_required',
            configKey: 'mail_required', label: 'bat_buoc_nhap_email'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_mail_valid',
            configKey: 'mail_valid', label: 'email_khong_dung_dinh_dang'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwSendCV'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_phone_valid',
            configKey: 'phone_valid', label: 'so_dien_thoai_khong_dung_dinh_dang'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_mail_valid',
            configKey: 'mail_valid', label: 'email_khong_dung_dinh_dang'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_success',
            configKey: 'success', label: 'gui_thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_error',
            configKey: 'error', label: 'gui_khong_thanh_cong'
          }"></ng-container>
        </ng-container>
      </li>

      <ng-container *ngIf="['AtwButtonPayment', 'AtwButtonPaymentOnline', 'AtwButtonBuyNow'].includes(objectChoosing.component)">
        <!-- CẤU HÌNH KHI CHƯA ĐĂNG NHẬP -->
        <li nz-submenu nzTitle="{{'cau_hinh_khi_CHUA_dang_nhap' | translate}}" [(nzOpen)]="openMap.menu13"
        (nzOpenChange)="openHandler('menu13')">
          <!-- Cấu hình nội dung thông báo và thời gian hiển thị thông báo -->
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_login_notice',
            configKey: 'login_notice', label: 'thong_bao_dang_nhap'
          }"></ng-container>

          <!-- Cấu hình liên kết -->
          <app-link-page-config [objectChoosing]="objectChoosing" [blocks_of_page]="blocks_of_page"
          [staticdata]="staticdata" [id_object]="objectChoosing._id" [linkStaticdata]="staticdata.not_logged_link">
          </app-link-page-config>
          <!-- Thời gian chuyển trang sau khi hiển thị thông báo -->
          <div *ngIf="staticdata.not_logged_link?.type_link && staticdata.not_logged_link.type_link != 'none'"
          style="display:flex; justify-content:space-between; align-items:center">
            <span style="line-height:1.2; width: 60%">
              {{ 'thoi_gian_chuyen_trang_sau_khi_hien_thi_thong_bao' | translate }}
              <span style="font-weight: bold;"> (ms)</span>
            </span>
            <nz-input-number
              [nzMin]="0" [nzMax]="5000" [nzStep]="100"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="staticdata.not_logged_link?.page_delay_after_noti | vhnumber"
              (ngModelChange)="staticdata.not_logged_link.page_delay_after_noti = $event"
              (nzBlur)="updateStaticData()">
            </nz-input-number>
          </div>
        </li>
      </ng-container>

      <ng-container *ngIf="['AtwButtonPayment', 'AtwButtonBuyNow'].includes(objectChoosing.component)">
        <!-- CẤU HÌNH KHI ĐÃ ĐĂNG NHẬP -->
        <li nz-submenu nzTitle="{{'cau_hinh_khi_DA_dang_nhap' | translate}}" [(nzOpen)]="openMap.menu14"
        (nzOpenChange)="openHandler('menu14')">
          <!-- Cấu hình liên kết -->
          <app-link-page-config [objectChoosing]="objectChoosing" [blocks_of_page]="blocks_of_page"
          [staticdata]="staticdata" [id_object]="objectChoosing._id" [linkStaticdata]="staticdata.logged_link">
          </app-link-page-config>
          <!-- Thời gian chuyển trang sau khi hiển thị thông báo -->
          <div *ngIf="staticdata.logged_link?.type_link && staticdata.logged_link.type_link != 'none'"
          style="display:flex; justify-content:space-between; align-items:center">
            <span style="line-height:1.2; width: 60%">
              {{ 'thoi_gian_chuyen_trang_sau_khi_hien_thi_thong_bao' | translate }}
              <span style="font-weight: bold;"> (ms)</span>
            </span>
            <nz-input-number
              [nzMin]="0" [nzMax]="5000" [nzStep]="100"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="staticdata.logged_link?.page_delay_after_noti | vhnumber"
              (ngModelChange)="staticdata.logged_link.page_delay_after_noti = $event"
              (nzBlur)="updateStaticData()">
            </nz-input-number>
          </div>
        </li>
      </ng-container>

      <!-- Cấu hình loại hiển thị khi hết hàng -->
      <li *ngIf="['AtwButtonAddToCart'].includes(objectChoosing.component)" nz-submenu nzTitle="{{'loai_hien_thi_khi_het_hang' | translate}}"
        [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
        <nz-select [ngModel]="config.out_stock_display_type" (ngModelChange)="config.out_stock_display_type = $event; updateConfig();">
          <nz-option nzValue="hide" nzLabel="{{'an_nut_di' | translate}}"></nz-option>
          <nz-option nzValue="disable" nzLabel="{{'vo_hieu_hoa' | translate}}"></nz-option>
          <nz-option nzValue="message" nzLabel="{{'thong_bao' | translate}}"></nz-option>
        </nz-select>

        <ng-container *ngIf="config.out_stock_display_type == 'disable'">
          <div class="config-name mt-2">
            <p>{{'bat_vo_hieu_hoa_tam_thoi' | translate}}</p>
            <nz-switch [ngModel]="config.is_disabled_temp" (ngModelChange)="config.is_disabled_temp = $event"></nz-switch>
          </div>
          <ng-container *ngIf="config.is_disabled_temp">
            <div class="config-name mt-2">
              <p>{{'do_mo' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="1" style="max-width: 50%" [nzStep]="0.01"
                [(ngModel)]="class['button--disabled']['opacity']" (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <div class="config-name mt-2">
              <p>{{'mau_chu' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['button--disabled']['color']"
                [style.background]="class['button--disabled']['color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
            <div class="config-name mt-2">
              <p>{{'mau_nen' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['button--disabled']['background-color']"
                [style.background]="class['button--disabled']['background-color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="config.out_stock_display_type == 'message'">
          <button class="w-100 mt-2" (click)="handleTryNoti()" nz-button nzType="primary">
            {{'thong_bao_thu' | translate}}
          </button>
          <div class="config-text mt-2" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung_thong_bao' | translate}}</mat-label>
              <textarea matInput style="height: 50px; line-height: 1.4"
                [ngModel]="staticdata['content_noti_out_stock_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata['content_noti_out_stock_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content_noti_out_stock');"></textarea>
            </mat-form-field>
            <div style="display:flex; justify-content:space-between; align-items:center">
              <span class="w-50" style="line-height:1.2;">{{'thoi_gian_hien_thong_bao' | translate}}</span>
              <nz-input-number [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="config.duration_noti?.out_stock | vhnumber" class="w-50"
                (ngModelChange)="config.duration_noti.out_stock = $event"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <app-rotate-config [classRotate]="class['button']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình thêm liên kết -->
      <li *ngIf="objectChoosing.component != 'AtwButtonCalculateCustom' && objectChoosing.component != 'AtwButtonOpenLink' && objectChoosing.component != 'AtwButtonAddToCart' && objectChoosing.component != 'AtwButtonBuyNow'" nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <!-- Không phải AtwButton -->
        <app-link-page-config [objectChoosing]="objectChoosing"
          *ngIf="objectChoosing.component !== 'AtwButton' && objectChoosing.component !== 'AtwButtonAddToCart'"
          [staticdata]="staticdata" [id_object]="objectChoosing._id"
          [blocks_of_page]="blocks_of_page"></app-link-page-config>

        <!-- <app-link-page-config [objectChoosing]="objectChoosing"
          *ngIf="objectChoosing.component === 'AtwButtonAddToCart'" [type_page]="['detail_product']"
          [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config> -->
        <!-- Là AtwButton -->
        <app-link-page-config [objectChoosing]="objectChoosing" *ngIf="objectChoosing.component === 'AtwButton'"
          [id_object]="objectChoosing._id" [staticdata]="staticdata" [blocks_of_page]="blocks_of_page"
          [dynamic_data]="objectChoosing.dynamic_data" [hasContact]="true">
        </app-link-page-config>
      </li>

      <!-- Cấu hình thêm liên kết -->
      <li *ngIf="objectChoosing.component == 'AtwButtonOpenLink'" nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
          <div class="type-link mb-2">
            <p class="type-link__title m-0" style="line-height: normal">{{'kieu_mo_lien_ket' | translate}}</p>
            <nz-select class="type-link__select" [(ngModel)]="staticdata.target" (ngModelChange)="updateStaticData()"
              nzPlaceHolder="{{'kieu_mo_lien_ket' | translate}}" allowClear>
              <nz-option [nzValue]="'_blank'" nzLabel="{{'mo_trang_moi' | translate}}"></nz-option>
              <nz-option [nzValue]="'_self'" nzLabel="{{'mo_tai_trang_hien_tai' | translate}}"></nz-option>
            </nz-select>
          </div>

          <div class="type-link">
            <p class="type-link__title m-0" style="line-height: normal">{{'vi_tri_noi_dung' | translate}}</p>
            <nz-select class="type-link__select" [(ngModel)]="staticdata.index_reference_link" (ngModelChange)="updateStaticData()"
              nzPlaceHolder="{{'kieu_mo_lien_ket' | translate}}" allowClear>
              <nz-option [nzValue]="0" nzLabel="{{'1' | translate}}"></nz-option>
              <nz-option [nzValue]="1" nzLabel="{{'2' | translate}}"></nz-option>
              <nz-option [nzValue]="2" nzLabel="{{'3' | translate}}"></nz-option>
              <nz-option [nzValue]="3" nzLabel="{{'4' | translate}}"></nz-option>
              <nz-option [nzValue]="4" nzLabel="{{'5' | translate}}"></nz-option>
            </nz-select>
          </div>

      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['button']"
          [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'button'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- TEMPLATE: CẤU HÌNH THÔNG BÁO -->
  <ng-template #notificationBlock let-dataKey="dataKey" let-configKey="configKey" let-label="label">
    <div class="config-text" style="width: 100%">
      <!-- Cấu hình nội dung -->
      <mat-form-field style="width: 100%">
        <mat-label> {{label | translate}}</mat-label>
        <textarea matInput
          [ngModel]="staticdata[dataKey]"
          (ngModelChange)="staticdata[dataKey] = $event"
          (blur)="updateStaticData()"></textarea>
      </mat-form-field>
      <!-- Cấu hình thời gian hiển thị thông báo -->
      <div style="display:flex; justify-content:space-between; align-items:center">
        <span class="w-50" style="line-height:1.2;">{{ 'thoi_gian_hien_thong_bao' | translate }}</span>
        <nz-input-number
          [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
          [ngStyle]="{ marginLeft: '16px', width: '40%' }"
          [ngModel]="config.duration_noti?.[configKey] | vhnumber"
          (ngModelChange)="config.duration_noti[configKey] = $event"
          (nzBlur)="updateConfig()" class="w-50">
        </nz-input-number>
      </div>
      <hr />
    </div>
  </ng-template>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['button']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata"
        [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color'].background"
          type="button" [disabled]="!config['background-color'].gradient_check"
          [style.background]="config['background-color'].background" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
        [disabled]="!config['background-color'].gradient_check"
        [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['background-color'].gradient_direction === type.direction">
      </button>
    </div>
  </div>
</div>